<template>
  <!-- <div v-if="$route.name == 'main'" class="video">
     <video autoplay muted loop>
       <source src="@/assets/img/main_video.mp4" type="video/webm" />
       <source src="@/assets/img/main_video.mp4" type="video/mp4" />
     </video>
  </div> -->
  <div :class="{fx : $route.name === 'main'}">
    <main-header v-if="$route.name !== 'partnerCashList' && $route.name !== 'partnerBettingList' && $route.name !== 'partnerList' && $route.name !== 'partnerCalculationList' && $route.name !== 'partnerCalculationUserList' && $route.name !== 'partnerMemberList' && $route.name !== 'partnerMoneyMoveList'" />
  </div>
  <template v-if="$route.name === 'main'">
    <div class="mainWrap">
      <div class="left">
        <ul>
          <li><a @click="goPageByName('charge')">{{ $t('front.gameCategory.cashC') }}</a></li>
          <li><a @click="goPageByName('exchange')">{{ $t('front.gameCategory.cashE') }}</a></li>
          <li><a @click="goPageByName('csCenter')">{{ $t('front.common.cscenter') }}</a></li>
          <li><a @click="goPageByName('message')">{{ $t('front.message.msg') }}</a></li>
          <li><a @click="goPageByName('notice')">{{ $t('front.common.notices') }}</a></li>
          <li><a @click="goPageByName('bettingList')">{{ $t('front.mypage.betList') }}</a></li>
        </ul>
        <div>
          <a><img src="@/assets/img/btn_casino.gif" /></a>
          <a><img src="@/assets/img/btn_slot.gif" /></a>
          <!-- <a><img src="@/assets/img/btn_hd.gif" /></a> -->
        </div>
      </div>
      <div class="center">
        <router-view :key="$route.fullPath"></router-view>
        <main-footer v-if="banner" />
      </div>
      <div class="right">
        <div>
          <!-- <a :href="siteOption['sns2Link']"><img src="@/assets/img/banner1.gif" /></a> -->
          <!-- <a><img src="@/assets/img/banner2.gif" /></a> -->
          <!-- <a :href="siteOption['sns2Link']"><img src="@/assets/img/banner3.gif" /></a> -->
          <a :href="siteOption['sns2Link']"><img src="@/assets/img/banner4.gif" /></a>
          <a><img src="@/assets/img/banner5.gif" /></a>
          <a><img src="@/assets/img/banner6.gif" /></a>
          <!-- <a><img src="@/assets/img/banner7.gif" /></a> -->
        </div>
      </div>
    </div>
  </template>
  <template v-else>
    <router-view :key="$route.fullPath"></router-view>
    <main-footer v-if="banner" />
  </template>
  <slot-list v-if="isSlotOpen" :groupCode="groupCode" :codeName="codeName" :code="code" @isSlot="isSlotOpen = false"></slot-list>
  <loading></loading>
</template>

<script>
import MainHeader from './Header'
import MainFooter from './Footer'
import SlotList from '@/components/game/SlotList'
import { mapState } from 'vuex'
import Loading from '@/components/common/Loading.vue'

export default {
  name: 'DefaultLayout',
  components: {
    Loading,
    SlotList,
    MainHeader,
    MainFooter
  },
  computed: {
    ...mapState([
      'banner',
      'siteOption'
    ])
  },
  mounted () {
    this.emitter.on('isSlot', (data) => {
      if (data) {
        const groupCode = data.groupCode
        const codeName = data.codeName
        const code = data.code
        this.getSlotOpen(groupCode, codeName, code)
      } else {
        this.isSlotOpen = false
      }
    })
  },
  data () {
    return {
      isSlotOpen: false,
      groupCode: '',
      codeName: '',
      code: '',
      isLoading: false
    }
  },
  methods: {
    getSlotOpen (groupCode, codeName, code) {
      if (this.userData) {
        this.groupCode = groupCode
        this.codeName = codeName
        this.code = code
        this.isSlotOpen = true
      } else {
        this.onCheck('front.error.afterSignin')
      }
    }
  }
}
</script>

<style>
.fade-enter {
  opacity: 0;
}

.fade-enter-active {
  transition: opacity 0.5s ease-in;
}

.fade-leave-active {
  transition: opacity 0.2s ease-in;
}

.fade-leave-to {
  opacity: 0;
}

.slide-fade-enter {
  transform: translateX(10px);
  opacity: 0;
}

.slide-fade-enter-active,
.slide-fade-leave-active {
  transition: all 0.2s ease;
}

.slide-fade-leave-to {
  transform: translateX(-10px);
  opacity: 0;
}

.slide-up-enter {
  transform: translateY(185px);
  opacity: 0;
}

.slide-up-enter-active,
.slide-up-leave-active {
  transition: all 0.3s ease;
}

.slide-up-leave-to {
  transform: translateY(0px);
  opacity: 0;
}
.video {width: 100%;max-height: 520px;overflow: hidden;position: relative;}
.video video {height: 100%;width: 100%;object-fit: cover;vertical-align: bottom;}

.mainWrap {
    width: 1900px;
    margin: 0 auto;
    display: flex;
    justify-content: center;
    gap: 15px;
    padding-top: 138px;
    position: sticky;
}
.mainWrap .center {
    width: 1260px;
    height: calc(100vh - 153px);
    overflow-y: overlay;
    overflow-x: hidden;
    -ms-overflow-style: none;
}
.mainWrap .center::-webkit-scrollbar{
  display:none;
}
.mainWrap .left {
    width: 300px;
}
.mainWrap .right {
    width: 300px;
}
.mainWrap .left,
.mainWrap .right {padding-top: 10px;}
.mainWrap .left img,
.mainWrap .right img {width: 100%;}
.mainWrap .left ul {display: flex;flex-wrap: wrap;gap: 1px;margin-bottom: 5px;}
.mainWrap .left ul li {
    width: calc(33.33% - 1px);
    height: 44px;
    background: linear-gradient(180deg, #272727, #101010);
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    font-size: 12px;
    text-shadow: 1px 1px 5px rgb(0 0 0 / 100%);
    background-clip: padding-box;
    border: 1px solid transparent;
    border-image: linear-gradient(to bottom, #000000, #fbdf9f) 1;
    box-sizing: border-box;
}
.mainWrap .left ul li:nth-child(1),
.mainWrap .left ul li:nth-child(2),
.mainWrap .left ul li:nth-child(3) {background: linear-gradient(180deg, #fddf79, #977345);}
</style>
